import React from "react";

const CalenderArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
    <path d="M5.83301 10.8335L0.833008 5.8335L5.83301 0.833496" stroke="#4A5565" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default CalenderArrow;

